import SongStore from '../stores/SongStore';

import QueueSequenceAction from '../actions/QueueSequenceAction';
import NoteToggleAction from '../actions/NoteToggleAction';

class Launchpad {
	constructor(midiLayer, dispatcher, input, output) {
		this.midiLayer = midiLayer;
		this.dispatcher = dispatcher;

		this.input = input;
		this.output = output;

		this.songStore = this.dispatcher.getStore(SongStore);

		this.view = "sequence_grid";

		this.sequenceOffset = 0;
		this.noteXOffset = 0;
		this.noteYOffset = 0;


		this.colours = {
			off: 12,
			red: 15,
			amber: 63,
			yellow: 62,
			green: 60,
			fred: 11,
			famber: 59,
			fyellow: 58,
			fgreen: 56
		};

		this.grid = [];

		for (var i = 0; i < 8; i++) {
			this.grid.push([]);
			for (var j = 0; j < 8; j++) {
				this.grid[i].push(this.colours.off);
			}
		}

		this.songStore.on("LAUNCHPAD_SEQUENCE_GRID", this.refreshSequenceGrid.bind(this));
		this.songStore.on("LAUNCHPAD_NOTE_GRID", this.refreshNoteGrid.bind(this));

		this.send([176, 0, 40]);

		this.refreshSequenceGrid();
	}

	song() {
	    return this.songStore.song;
    }

	receiveInput(event) {

		if(event.type == "note-on") {
			var row = Math.floor(event.data[1]/16)+this.sequenceOffset;
			var col = event.data[1] % 16;

			if(this.view == "sequence_grid" && col < 7) {
				this.dispatcher.executeAction(QueueSequenceAction, {
					channel: col,
					sequence: row,
					select: true
				});

			} else if(this.view == "note_grid" && col < 8) {
				console.log(event);
				this.dispatcher.executeAction(NoteToggleAction, {
					note: row+(this.noteYOffset*8),
					bar: Math.floor(this.noteXOffset/2)+1,
					beat: col+((this.noteXOffset%2)*8)
				});
			}

		}

		if(event.type == "control-change" && event.data[2] == 127) {
			switch (event.data[1]) {
				case 104: // up
					if(this.view == "sequence_grid" && this.sequenceOffset > 0) {
						this.sequenceOffset--;
						this.refreshSequenceGrid();
					} else if(this.view == "note_grid" && this.noteYOffset == 1) {
						this.noteYOffset--;
						this.refreshNoteGrid();
					}
					break;
				case 105: // down
					if(this.view == "sequence_grid" && this.sequenceOffset < 4) {
						this.sequenceOffset++;
						this.refreshSequenceGrid();
					} else if(this.view == "note_grid" && this.noteYOffset == 0) {
						this.noteYOffset++;
						this.refreshNoteGrid();
					}
					break;
				case 106: // left
					if(this.view == "note_grid") {
						this.noteXOffset--;
						if(this.noteXOffset < 0) {
							this.noteXOffset = 0;
						}
						this.refreshNoteGrid();
					}
					break;
				case 107: // right
					if(this.view == "note_grid") {
						this.noteXOffset++;
						if(this.noteXOffset > this.song().getSelectedSequence().bars*2-1) {
							this.noteXOffset--;
						}
						this.refreshNoteGrid();
					}
					break;
				case 108: // sequence
					this.view = "sequence_grid";
					console.log(this.view);
					this.refreshSequenceGrid();
					break;
				case 109: // note
					this.view = "note_grid";
					console.log(this.view );
					this.refreshNoteGrid();
					break;
			}
		}

	}

	blockInput(id) {
		return this.input == id;
	}

	refreshSequenceGrid() {
		if(this.view == "sequence_grid") {
		    const song = this.song();
			this.cleanGrid();
			for(var i = 0; i < 7; i++) {
				var channel = song.channels[i];
				for (var j = 0; j < 8; j++) {
					var seq = channel.sequences[j+this.sequenceOffset];
					if (seq.playing) {
						this.grid[i][j] = this.colours.green;
					} else if (seq.queued) {
						this.grid[i][j] = this.colours.fgreen;
					} else if(!seq.empty) {
						this.grid[i][j] = this.colours.amber;
					}
				}
			}
			this.update();
		}


	}

	refreshNoteGrid(payload) {

		if(payload && payload.bar) {
			this.noteXOffset = (payload.bar-1)*2 + this.noteXOffset%2;
		}

		if(this.view == "note_grid") {
			this.cleanGrid();

			var sequence = this.song().getSelectedSequence();

			var beats = sequence.beats;

			if(this.noteXOffset/2 >= sequence.bars) {
				this.noteXOffset = 0;
			}

			for(var i = 0; i < 8; i++) {
				var notes = beats[i+(this.noteXOffset*8)];
				notes.forEach((note) => {
					note -= (this.noteYOffset*8);
					if(note >= 0 && note < 8) {
						this.grid[i][note] = this.colours.green;
					}
				});
			}


			this.update();
		}
	}

	cleanGrid() {
		for (var i = 0; i < 8; i++) {
			for (var j = 0; j < 8; j++) {
				this.grid[i][j] = this.colours.off;
			}
		}
	}

	send(data) {
		this.midiLayer.send(this.output, data);
	}

	update() {

		for (var i = 0; i < 8; i++) {
			for (var j = 0; j < 8; j+=2) {
				this.send([146, this.grid[j][i], this.grid[j+1][i]]);
			}
		}

		if(this.view == "sequence_grid") {
			this.send([146, 12, 12]);
			this.send([146, 12, 12]);
			this.send([146, 12, 12]);
			this.send([146, 12, 12]);
			this.send([146, this.colours.red, this.colours.red]);
			this.send([146, 12, 12]);
			this.send([146, this.colours.yellow, this.colours.green]);
		} else if(this.view == "note_grid") {
			this.send([146, 12, 12]);
			this.send([146, 12, 12]);
			this.send([146, 12, 12]);
			this.send([146, 12, 12]);
			this.send([146, this.colours.red, this.colours.red]);
			this.send([146, this.colours.red, this.colours.red]);
			this.send([146, this.colours.green, this.colours.yellow]);
		}

		this.send([0x90, 119, this.grid[j-1][i-1]]);
	}

}

export default Launchpad;
